import { render, staticRenderFns } from "./Questionar.vue?vue&type=template&id=8c2dcefa&lang=pug&"
import script from "./Questionar.vue?vue&type=script&lang=js&"
export * from "./Questionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports